<div class="email__template">
  <div class="email__template--header">
    @if (userRegistration) {
      <span>This Account signup link has expired.</span>
    }
    @if (!userRegistration) {
      <span>This Reset password link has expired.</span>
    }
  </div>
  <div class="email__template--body no-data">
    <p>
      We are sorry. The link you received to set up your account automatically expires within 72 hours. @if (userRegistration) {
      <span>Please contact your Internet
      of Clean solution manager to have your account authorization reset.</span>
    }
    @if (!userRegistration) {
      <span> Please try again using the reset password link from application to get the new email for reset password.</span>
    }
  </p>
  <p>
    If you have received this in error, please disregard the email and no further action is needed.
  </p>
</div>
</div>
